import { render, staticRenderFns } from "./tenantInstructionBatchLobDialog.vue?vue&type=template&id=2ea4b5c8&"
import script from "./tenantInstructionBatchLobDialog.vue?vue&type=script&lang=js&"
export * from "./tenantInstructionBatchLobDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ea4b5c8')) {
      api.createRecord('2ea4b5c8', component.options)
    } else {
      api.reload('2ea4b5c8', component.options)
    }
    module.hot.accept("./tenantInstructionBatchLobDialog.vue?vue&type=template&id=2ea4b5c8&", function () {
      api.rerender('2ea4b5c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantInstructionBatchLobDialog.vue"
export default component.exports